import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

const { colors, devices, spaces } = theme;

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledCard = styled(forwardRef(({ desktop, mobile, fullHeight, fullWidth, radius, noBorder, noPadding, noPaddingMobile, ...props }, ref) => <div ref={ref} {...props} />))`
  padding: ${spaces.large}px;
  border: 1px solid ${hexToRGBA(colors.gray.secondary, 0.16)};
  border-radius: 24px;
  background: ${colors.white};

  ${({ radius }) =>
    radius &&
    css`
      border-radius: ${radius}px;
    `}

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100%;
    `}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  ${({ noBorder }) =>
    noBorder &&
    css`
      border: none;
    `}

  ${({ noPadding }) =>
    noPadding &&
    css`
      padding: 0;
    `}

  ${({ mobile }) =>
    mobile &&
    css`
      display: none;
    `}

  @media ${devices.tablet} {
    padding: ${spaces.regular}px;

    ${({ noPadding }) =>
      noPadding &&
      css`
        padding: 0;
      `}

    ${({ noPaddingMobile }) =>
      noPaddingMobile &&
      css`
        padding: 0;
      `}

    ${({ desktop }) =>
      desktop &&
      css`
        display: none;
      `}

    ${({ mobile }) =>
      mobile &&
      css`
        display: block;
      `}
  }
`;

// eslint-disable-next-line react/display-name
const Card = forwardRef(({ mobile, desktop, fullHeight, fullWidth, noBorder, noPadding, radius, children, ...restProps }, ref) => (
  <StyledCard ref={ref} mobile={mobile} desktop={desktop} fullHeight={fullHeight} fullWidth={fullWidth} noBorder={noBorder} noPadding={noPadding} radius={radius} {...restProps}>
    {children}
  </StyledCard>
));

Card.propTypes = {
  mobile: PropTypes.bool,
  desktop: PropTypes.bool,
  fullHeight: PropTypes.bool,
  fullWidth: PropTypes.bool,
  noBorder: PropTypes.bool,
  noPadding: PropTypes.bool,
  radius: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export default Card;
